export var PREMIUM_EXCLUSIVE_TAG_TRANSLATION_KEY = 'premium-exclusive-tag';